import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../constants/common'

import { BROWSER_TAB_LOADING_TEXT_KEY } from './usePageBrowserTabTitle.constants'
import {
  createTabTitle,
  getTabErrorTitleKey,
} from './usePageBrowserTabTitle.utils'

export function usePageBrowserTabTitle({
  errorStatus,
  isEnabled = true,
  isLoading = false,
  pageTitle,
} = EMPTY_OBJECT) {
  const { t } = useTranslation()

  const errorKey = getTabErrorTitleKey(errorStatus)

  const title = errorKey
    ? t(errorKey)
    : isLoading
      ? `${t(BROWSER_TAB_LOADING_TEXT_KEY)}...`
      : pageTitle

  const nextTitle = createTabTitle({ title })

  useEffect(() => {
    if (isEnabled && document.title !== nextTitle) {
      document.title = nextTitle
    }
  }, [isEnabled, nextTitle])
}
